import { AvForm, AvField } from "availity-reactstrap-validation"
import React, { useEffect, useState } from "react"
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
  Alert,
} from "reactstrap"

import EnvironmentalAudit from "services/EnvironmentalAudit.service"
const user = JSON.parse(localStorage.getItem("authUser"))
const environmentalAuditService = new EnvironmentalAudit(user)

const BASE_URL = process.env.REACT_APP_BASE_URL

const AuditPhaseTwo = props => {
  const [modal, setModal] = useState(false)
  const [developerDetails, setDeveloperDetails] = useState({
    developer_name: "",
    developer_phone: "",
    developer_email: "",
    developer_address: "",
    developer_rapep_number: "",
  })
  const [files, setFiles] = useState({
    auditReportWord: null,
    auditReportPDF: null,
    rapepCertificate: null,
    supportingDocuments: null,
  })

  const [success, setsuccess] = useState(false)
  const [error, seterror] = useState(false)

  useEffect(() => {
    // console.log("appDetails", props.applicationDetails)
    setDeveloperDetails({
      developer_address: props.applicationDetails.developer_address? props.applicationDetails.developer_address : "",
      developer_email: props.applicationDetails.developer_email? props.applicationDetails.developer_email : "",
      developer_name: props.applicationDetails.developer_name? props.applicationDetails.developer_name : "",
      developer_phone: props.applicationDetails.developer_phone? props.applicationDetails.developer_phone : "",
      developer_rapep_number: props.applicationDetails.developer_rapep_number? props.applicationDetails.developer_rapep_number : "",
      developer_representative: props.applicationDetails.developer_representative? props.applicationDetails.developer_representative : "",

    })
    // 
  }, [])

  const toggle = () => setModal(!modal)

  const handleInputChange = e => {
    const { name, value } = e.target
    setDeveloperDetails(prevState => ({
      ...prevState,
      [name]: value,
    }))
  }

  const handleFileChange = e => {
    const { name, files } = e.target
    setFiles(prevState => ({
      ...prevState,
      [name]: files[0],
    }))
  }

  const submitForm = () => {
    const uploaded_files = [] // Array to store uploaded file data

    Object.entries(files).forEach(([key, file]) => {
      if (file) {
        // Ensure that a file is provided for the field
        let description = ""

        // Map the key to the correct description
        switch (key) {
          case "auditReportWord":
            description = "Audit_Report_Word"
            break
          case "auditReportPDF":
            description = "Audit_Report_PDF"
            break
          case "rapepCertificate":
            description = "Developer_RAPEP_Certificate"
            break
          case "envAuditReport":
            description = "Environmental_Audit_Report"
            break
          case "supportingDocuments":
            description = "Other_Supporting_Documents"
            break
          default:
            description = "Unknown Document"
        }

        uploaded_files.push({
          application_id: props.applicationDetails.application_id,
          description: description,
          file: file,
        })
      }
    })

    // console.log("files ", uploaded_files)

    const formDetails = {
      ...props.applicationDetails,
      ...developerDetails,
    }

    // console.log("form details",formDetails)

    

    environmentalAuditService.saveApplication(formDetails).then(response=>{
        console.log("submit form res =>", response)

        if (response.status) {
            environmentalAuditService.bulkFileUpload(uploaded_files)

            seterror(false)
            setsuccess(true)
            setTimeout(() => {
              window.location.reload();
            }, 2000);
        } else {
            seterror(true)
            setsuccess(false)
        }
    })
  }

  return (
    <div>
      <Alert color="warning">
        Action needed! Your Terms of Reference document is ready. Please click
        on the button below to complete the necessary actions.
      </Alert>

      <Button color="info" className="pull-right" onClick={toggle}>
        Complete Actions
      </Button>

      <Modal size="lg" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          EIA Licensed Firm/Expert Details
        </ModalHeader>
        <ModalBody>
            {success? <Alert color="success">Action succesfully completed!</Alert>: null}
            {error? <Alert color="danger">Error encountered. Please try again.</Alert>: null}
          <AvForm onValidSubmit={submitForm}>
            <AvField
              name="developer_name"
              label="Firm/Expert Name"
              type="text"
              placeholder="Enter Firm/Expert name"
              value={developerDetails.developer_name}
              onChange={handleInputChange}
              validate={{
                required: {
                  value: true,
                  errorMessage: "Firm/Expert name is required",
                },
                minLength: {
                  value: 3,
                  errorMessage: "Name must be at least 3 characters",
                },
              }}
            />
            <AvField
              name="developer_phone"
              label="Firm/Expert Phone"
              type="text"
              placeholder="Enter Firm/Expert phone"
              value={developerDetails.developer_phone}
              onChange={handleInputChange}
              validate={{
                required: {
                  value: true,
                  errorMessage: "Phone number is required",
                },
                pattern: {
                  value: "^[0-9]+$",
                  errorMessage: "Only numbers are allowed",
                },
                minLength: {
                  value: 10,
                  errorMessage: "Phone number must be 10 digits",
                },
              }}
            />
            <AvField
              name="developer_email"
              label="Firm/Expert Email"
              type="email"
              placeholder="Enter Firm/Expert email"
              value={developerDetails.developer_email}
              onChange={handleInputChange}
              validate={{
                required: { value: true, errorMessage: "Email is required" },
                email: { value: true, errorMessage: "Invalid email format" },
              }}
            />
            <AvField
              name="developer_address"
              label="Firm/Expert Address"
              type="text"
              placeholder="Enter Firm/Expert address"
              value={developerDetails.developer_address}
              onChange={handleInputChange}
              validate={{
                required: { value: true, errorMessage: "Address is required" },
              }}
            />
            <AvField
              name="developer_rapep_number"
              label="Firm/Expert RAPEP Number"
              type="text"
              placeholder="Enter RAPEP number"
              value={developerDetails.developer_rapep_number}
              onChange={handleInputChange}
              validate={{
                required: {
                  value: true,
                  errorMessage: "RAPEP number is required",
                },
              }}
            />
            <br />

            <FormGroup>
              <Label for="auditReportWord">Audit Report (Word)</Label>
              <AvField
                type="file"
                className="form-control"
                name="auditReportWord"
                id="auditReportWord"
                accept=".doc,.docx"
                onChange={handleFileChange}
                required
              />
            </FormGroup>
            <FormGroup>
              <Label for="auditReportPDF">Audit Report (PDF)</Label>
              <AvField
                type="file"
                className="form-control"
                name="auditReportPDF"
                id="auditReportPDF"
                accept=".pdf"
                onChange={handleFileChange}
                required
              />
            </FormGroup>
            <FormGroup>
              <Label for="rapepCertificate">Firm/Expert RAPEP Certificate</Label>
              <AvField
                type="file"
                className="form-control"
                name="rapepCertificate"
                id="rapepCertificate"
                accept=".pdf,.doc,.docx"
                onChange={handleFileChange}
                required
              />
            </FormGroup>
            <FormGroup>
              <Label for="envAuditReport">Firm/Expert RAPEP Certificate</Label>
              <AvField
                type="file"
                className="form-control"
                name="envAuditReport"
                id="envAuditReport"
                accept=".pdf,.doc,.docx"
                onChange={handleFileChange}
                required
              />
            </FormGroup>
   
            <FormGroup>
              <Label for="supportingDocuments">
                Other Supporting Documents
              </Label>
              <AvField
                type="file"
                className="form-control"
                name="supportingDocuments"
                id="supportingDocuments"
                accept=".pdf,.doc,.docx"
                onChange={handleFileChange}
              />
            </FormGroup>
            <br></br>
            <Button color="primary" type="submit">
              Submit
            </Button>
          </AvForm>
        </ModalBody>

        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  )
}

export default AuditPhaseTwo
